import { useAtomValue } from "jotai";
import { questionnaireVisibilityAtom } from "../state/questionnaireVisibilityAtom";

/**
 * Get a single question's visibility.
 *
 * Uses selectAtom so only re-renders when this specific question's
 * visibility changes, not on every questionnaire state update.
 * The processQuestionnaire step stamps each question's `visible` prop
 * so Question can fall back to props.visible during hydration.
 *
 * @example const isVisible = useVisibility('optional_field');
 * @see useVisibilityMap - all visibility states
 */
export function useVisibility(questionName: string): boolean | undefined {
  return useAtomValue(questionnaireVisibilityAtom(questionName));
}
